[
  {
    "date": "2025-12-12 21:15:00",
    "open": 100000,
    "low": 99579.9,
    "high": 100568.9,
    "close": 100259,
    "volume": 49659352
  },
  {
    "date": "2025-12-12 21:30:00",
    "open": 100259,
    "low": 98598.64,
    "high": 100815.81,
    "close": 99524.39,
    "volume": 52270945
  },
  {
    "date": "2025-12-12 21:45:00",
    "open": 99524.39,
    "low": 99201.26,
    "high": 101186.99,
    "close": 100105.21,
    "volume": 51249893
  },
  {
    "date": "2025-12-12 22:00:00",
    "open": 100105.21,
    "low": 97735.24,
    "high": 100263.27,
    "close": 99270.86,
    "volume": 41996087
  },
  {
    "date": "2025-12-12 22:15:00",
    "open": 99270.86,
    "low": 96629.55,
    "high": 101345.84,
    "close": 97990.45,
    "volume": 61182303
  },
  {
    "date": "2025-12-12 22:30:00",
    "open": 97990.45,
    "low": 97869.76,
    "high": 98515.08,
    "close": 98274.44,
    "volume": 50270739
  },
  {
    "date": "2025-12-12 22:45:00",
    "open": 98274.44,
    "low": 96212.91,
    "high": 101788.92,
    "close": 100020.75,
    "volume": 112911080
  },
  {
    "date": "2025-12-12 23:00:00",
    "open": 100020.75,
    "low": 99167.43,
    "high": 102626.66,
    "close": 100926.53,
    "volume": 44041659
  },
  {
    "date": "2025-12-12 23:15:00",
    "open": 100926.53,
    "low": 99687.62,
    "high": 104309.92,
    "close": 102045.21,
    "volume": 50042545
  },
  {
    "date": "2025-12-12 23:30:00",
    "open": 102045.21,
    "low": 99918.5,
    "high": 103532.92,
    "close": 103273.26,
    "volume": 55388973
  },
  {
    "date": "2025-12-12 23:45:00",
    "open": 103273.26,
    "low": 101938.51,
    "high": 105065.02,
    "close": 104162.38,
    "volume": 56329835
  },
  {
    "date": "2025-12-13 00:00:00",
    "open": 104162.38,
    "low": 102292.68,
    "high": 105635.67,
    "close": 103247.77,
    "volume": 45692315
  },
  {
    "date": "2025-12-13 00:15:00",
    "open": 103247.77,
    "low": 102649.45,
    "high": 104862.46,
    "close": 104235.02,
    "volume": 49926240
  },
  {
    "date": "2025-12-13 00:30:00",
    "open": 104235.02,
    "low": 103776.35,
    "high": 104582.17,
    "close": 104073.56,
    "volume": 57720142
  },
  {
    "date": "2025-12-13 00:45:00",
    "open": 104073.56,
    "low": 101654.88,
    "high": 105809.11,
    "close": 105382.99,
    "volume": 58777729
  },
  {
    "date": "2025-12-13 01:00:00",
    "open": 105382.99,
    "low": 102266.93,
    "high": 109165.25,
    "close": 107156.44,
    "volume": 47117009
  },
  {
    "date": "2025-12-13 01:15:00",
    "open": 107156.44,
    "low": 104013.81,
    "high": 109106.7,
    "close": 108740.8,
    "volume": 60250410
  },
  {
    "date": "2025-12-13 01:30:00",
    "open": 108740.8,
    "low": 108412.03,
    "high": 111599.45,
    "close": 110334.95,
    "volume": 47361376
  },
  {
    "date": "2025-12-13 01:45:00",
    "open": 110334.95,
    "low": 108022.84,
    "high": 111692.06,
    "close": 109569.07,
    "volume": 63928981
  },
  {
    "date": "2025-12-13 02:00:00",
    "open": 109569.07,
    "low": 107638.7,
    "high": 113284.31,
    "close": 111144.1,
    "volume": 40858260
  },
  {
    "date": "2025-12-13 02:15:00",
    "open": 111144.1,
    "low": 108774.46,
    "high": 111464.47,
    "close": 110282.47,
    "volume": 56723089
  },
  {
    "date": "2025-12-13 02:30:00",
    "open": 110282.47,
    "low": 109482.71,
    "high": 110935.26,
    "close": 109931.5,
    "volume": 86087637
  },
  {
    "date": "2025-12-13 02:45:00",
    "open": 109931.5,
    "low": 109097.06,
    "high": 110964.04,
    "close": 110777.68,
    "volume": 53867631
  },
  {
    "date": "2025-12-13 03:00:00",
    "open": 110777.68,
    "low": 110118.48,
    "high": 111276.61,
    "close": 110515.59,
    "volume": 55243094
  },
  {
    "date": "2025-12-13 03:15:00",
    "open": 110515.59,
    "low": 110105.15,
    "high": 111289.29,
    "close": 110791,
    "volume": 43802449
  },
  {
    "date": "2025-12-13 03:30:00",
    "open": 110791,
    "low": 107612.29,
    "high": 115127.59,
    "close": 112930.27,
    "volume": 47750057
  },
  {
    "date": "2025-12-13 03:45:00",
    "open": 112930.27,
    "low": 108414.8,
    "high": 118410.36,
    "close": 116090.17,
    "volume": 78177770
  },
  {
    "date": "2025-12-13 04:00:00",
    "open": 116090.17,
    "low": 115826.77,
    "high": 116253.87,
    "close": 115968.72,
    "volume": 61995380
  },
  {
    "date": "2025-12-13 04:15:00",
    "open": 115968.72,
    "low": 111811.33,
    "high": 119663.57,
    "close": 118464.95,
    "volume": 51470370
  },
  {
    "date": "2025-12-13 04:30:00",
    "open": 118464.95,
    "low": 116970.87,
    "high": 119345.04,
    "close": 117764.33,
    "volume": 61994916
  },
  {
    "date": "2025-12-13 04:45:00",
    "open": 117764.33,
    "low": 117569.21,
    "high": 118048.74,
    "close": 117830.48,
    "volume": 58039176
  },
  {
    "date": "2025-12-13 05:00:00",
    "open": 117830.48,
    "low": 114102.76,
    "high": 122761.82,
    "close": 120136.03,
    "volume": 60518898
  },
  {
    "date": "2025-12-13 05:15:00",
    "open": 120136.03,
    "low": 117039.42,
    "high": 121492.6,
    "close": 119076.89,
    "volume": 55140533
  },
  {
    "date": "2025-12-13 05:30:00",
    "open": 119076.89,
    "low": 115027.05,
    "high": 120679.76,
    "close": 117165.06,
    "volume": 62961387
  },
  {
    "date": "2025-12-13 05:45:00",
    "open": 117165.06,
    "low": 116952.07,
    "high": 117363.23,
    "close": 117090.14,
    "volume": 44713147
  },
  {
    "date": "2025-12-13 06:00:00",
    "open": 117090.14,
    "low": 116925.56,
    "high": 117214.82,
    "close": 117068.19,
    "volume": 55774563
  },
  {
    "date": "2025-12-13 06:15:00",
    "open": 117068.19,
    "low": 116094.46,
    "high": 120360.94,
    "close": 118943.67,
    "volume": 64241747
  },
  {
    "date": "2025-12-13 06:30:00",
    "open": 118943.67,
    "low": 116867.14,
    "high": 120421.54,
    "close": 117630.93,
    "volume": 62902129
  },
  {
    "date": "2025-12-13 06:45:00",
    "open": 117630.93,
    "low": 115072.2,
    "high": 119599,
    "close": 116352.81,
    "volume": 41922884
  },
  {
    "date": "2025-12-13 07:00:00",
    "open": 116352.81,
    "low": 114511.51,
    "high": 117087.43,
    "close": 115734.62,
    "volume": 64195986
  },
  {
    "date": "2025-12-13 07:15:00",
    "open": 115734.62,
    "low": 113057.87,
    "high": 119416.26,
    "close": 117030.14,
    "volume": 54706825
  },
  {
    "date": "2025-12-13 07:30:00",
    "open": 117030.14,
    "low": 112700.88,
    "high": 123989.89,
    "close": 119453.08,
    "volume": 53747936
  },
  {
    "date": "2025-12-13 07:45:00",
    "open": 119453.08,
    "low": 116785.46,
    "high": 120328.99,
    "close": 117332.84,
    "volume": 64318358
  },
  {
    "date": "2025-12-13 08:00:00",
    "open": 117332.84,
    "low": 115550.82,
    "high": 118562.15,
    "close": 118276.41,
    "volume": 56093273
  },
  {
    "date": "2025-12-13 08:15:00",
    "open": 118276.41,
    "low": 117944.6,
    "high": 121480.05,
    "close": 120091.36,
    "volume": 42867288
  },
  {
    "date": "2025-12-13 08:30:00",
    "open": 120091.36,
    "low": 119918.25,
    "high": 120366.1,
    "close": 120176.35,
    "volume": 63667842
  },
  {
    "date": "2025-12-13 08:45:00",
    "open": 120176.35,
    "low": 119734.64,
    "high": 120945.54,
    "close": 120460.45,
    "volume": 46309770
  },
  {
    "date": "2025-12-13 09:00:00",
    "open": 120460.45,
    "low": 118383.32,
    "high": 123838.43,
    "close": 121612.54,
    "volume": 51060990
  },
  {
    "date": "2025-12-13 09:15:00",
    "open": 121612.54,
    "low": 105100.99,
    "high": 135313.52,
    "close": 113996.37,
    "volume": 179892752
  },
  {
    "date": "2025-12-13 09:30:00",
    "open": 113996.37,
    "low": 113879.81,
    "high": 115206.41,
    "close": 114401.65,
    "volume": 44850191
  },
  {
    "date": "2025-12-13 09:45:00",
    "open": 114401.65,
    "low": 113929.97,
    "high": 115393.57,
    "close": 114696.23,
    "volume": 42874382
  },
  {
    "date": "2025-12-13 10:00:00",
    "open": 114696.23,
    "low": 114465.15,
    "high": 115281.89,
    "close": 115010.91,
    "volume": 48756695
  },
  {
    "date": "2025-12-13 10:15:00",
    "open": 115010.91,
    "low": 88291.59,
    "high": 159327.59,
    "close": 132703.96,
    "volume": 146734221
  },
  {
    "date": "2025-12-13 10:30:00",
    "open": 132703.96,
    "low": 130900.32,
    "high": 134902.02,
    "close": 131171.48,
    "volume": 40461762
  },
  {
    "date": "2025-12-13 10:45:00",
    "open": 131171.48,
    "low": 130731.27,
    "high": 131359.39,
    "close": 131064.48,
    "volume": 49272229
  },
  {
    "date": "2025-12-13 11:00:00",
    "open": 131064.48,
    "low": 130541.82,
    "high": 131737.32,
    "close": 131488.59,
    "volume": 59335886
  },
  {
    "date": "2025-12-13 11:15:00",
    "open": 131488.59,
    "low": 124663.32,
    "high": 134690.07,
    "close": 129210.6,
    "volume": 50705680
  },
  {
    "date": "2025-12-13 11:30:00",
    "open": 129210.6,
    "low": 126791.82,
    "high": 130838.55,
    "close": 128285.92,
    "volume": 57168560
  },
  {
    "date": "2025-12-13 11:45:00",
    "open": 128285.92,
    "low": 126281.04,
    "high": 135038.98,
    "close": 130644.83,
    "volume": 52220749
  },
  {
    "date": "2025-12-13 12:00:00",
    "open": 130644.83,
    "low": 127560.11,
    "high": 131196.94,
    "close": 129557.9,
    "volume": 59545025
  },
  {
    "date": "2025-12-13 12:15:00",
    "open": 129557.9,
    "low": 129198.53,
    "high": 133876.42,
    "close": 131674.08,
    "volume": 64077149
  },
  {
    "date": "2025-12-13 12:30:00",
    "open": 131674.08,
    "low": 131327.38,
    "high": 131905.02,
    "close": 131514.17,
    "volume": 54816162
  },
  {
    "date": "2025-12-13 12:45:00",
    "open": 131514.17,
    "low": 131309.63,
    "high": 132071.31,
    "close": 131855.76,
    "volume": 44215599
  },
  {
    "date": "2025-12-13 13:00:00",
    "open": 131855.76,
    "low": 130345.03,
    "high": 134191.86,
    "close": 133706.29,
    "volume": 47591185
  },
  {
    "date": "2025-12-13 13:15:00",
    "open": 133706.29,
    "low": 133570.53,
    "high": 133931.66,
    "close": 133746.23,
    "volume": 103420296
  },
  {
    "date": "2025-12-13 13:30:00",
    "open": 133746.23,
    "low": 133028.15,
    "high": 137738.16,
    "close": 135590.86,
    "volume": 129637027
  },
  {
    "date": "2025-12-13 13:45:00",
    "open": 135590.86,
    "low": 134657.71,
    "high": 136068.91,
    "close": 135163.2,
    "volume": 54514478
  },
  {
    "date": "2025-12-13 14:00:00",
    "open": 135163.2,
    "low": 122999.13,
    "high": 144384.83,
    "close": 126034.5,
    "volume": 133277757
  },
  {
    "date": "2025-12-13 14:15:00",
    "open": 126034.5,
    "low": 125257.01,
    "high": 126515.36,
    "close": 126373.9,
    "volume": 54796804
  },
  {
    "date": "2025-12-13 14:30:00",
    "open": 126373.9,
    "low": 125207.64,
    "high": 128916.72,
    "close": 127347.87,
    "volume": 61355241
  },
  {
    "date": "2025-12-13 14:45:00",
    "open": 127347.87,
    "low": 124077.32,
    "high": 129007.38,
    "close": 126274.24,
    "volume": 60946218
  },
  {
    "date": "2025-12-13 15:00:00",
    "open": 126274.24,
    "low": 125640.37,
    "high": 127279.67,
    "close": 126652.72,
    "volume": 55302520
  },
  {
    "date": "2025-12-13 15:15:00",
    "open": 126652.72,
    "low": 126327.37,
    "high": 133279.82,
    "close": 129018.24,
    "volume": 53635577
  },
  {
    "date": "2025-12-13 15:30:00",
    "open": 129018.24,
    "low": 127109.92,
    "high": 130203.34,
    "close": 128420.6,
    "volume": 63185748
  },
  {
    "date": "2025-12-13 15:45:00",
    "open": 128420.6,
    "low": 127686.03,
    "high": 132764.83,
    "close": 129944.38,
    "volume": 56842268
  },
  {
    "date": "2025-12-13 16:00:00",
    "open": 129944.38,
    "low": 128351.1,
    "high": 130979.79,
    "close": 129210.74,
    "volume": 40440597
  },
  {
    "date": "2025-12-13 16:15:00",
    "open": 129210.74,
    "low": 127396.19,
    "high": 130843.37,
    "close": 128277.58,
    "volume": 44922600
  },
  {
    "date": "2025-12-13 16:30:00",
    "open": 128277.58,
    "low": 123934.42,
    "high": 129165.1,
    "close": 126606.53,
    "volume": 63603881
  },
  {
    "date": "2025-12-13 16:45:00",
    "open": 126606.53,
    "low": 118654.94,
    "high": 127188.52,
    "close": 123869.61,
    "volume": 41639932
  },
  {
    "date": "2025-12-13 17:00:00",
    "open": 123869.61,
    "low": 109734.98,
    "high": 134947.46,
    "close": 114212.45,
    "volume": 129874771
  },
  {
    "date": "2025-12-13 17:15:00",
    "open": 114212.45,
    "low": 114004.18,
    "high": 114796.28,
    "close": 114605.51,
    "volume": 53498505
  },
  {
    "date": "2025-12-13 17:30:00",
    "open": 114605.51,
    "low": 110134.11,
    "high": 117543.63,
    "close": 113039.9,
    "volume": 61875575
  },
  {
    "date": "2025-12-13 17:45:00",
    "open": 113039.9,
    "low": 112097.19,
    "high": 113210.03,
    "close": 112716.11,
    "volume": 47807513
  },
  {
    "date": "2025-12-13 18:00:00",
    "open": 112716.11,
    "low": 111683.91,
    "high": 113806.6,
    "close": 113587.65,
    "volume": 63749597
  },
  {
    "date": "2025-12-13 18:15:00",
    "open": 113587.65,
    "low": 112567.11,
    "high": 114646.1,
    "close": 112720.68,
    "volume": 46103103
  },
  {
    "date": "2025-12-13 18:30:00",
    "open": 112720.68,
    "low": 109446.28,
    "high": 114953.89,
    "close": 111549.87,
    "volume": 46807078
  },
  {
    "date": "2025-12-13 18:45:00",
    "open": 111549.87,
    "low": 108807.38,
    "high": 113486.66,
    "close": 113320.53,
    "volume": 44467543
  },
  {
    "date": "2025-12-13 19:00:00",
    "open": 113320.53,
    "low": 107429.25,
    "high": 117809.67,
    "close": 111063.99,
    "volume": 42894032
  },
  {
    "date": "2025-12-13 19:15:00",
    "open": 111063.99,
    "low": 107740.21,
    "high": 112608.02,
    "close": 109610.62,
    "volume": 52585409
  },
  {
    "date": "2025-12-13 19:30:00",
    "open": 109610.62,
    "low": 108731.6,
    "high": 111325.46,
    "close": 110285.46,
    "volume": 61796951
  },
  {
    "date": "2025-12-13 19:45:00",
    "open": 110285.46,
    "low": 108571.63,
    "high": 113237.53,
    "close": 111430.89,
    "volume": 47883520
  },
  {
    "date": "2025-12-13 20:00:00",
    "open": 111430.89,
    "low": 108134.9,
    "high": 111909.15,
    "close": 110232.2,
    "volume": 40322950
  },
  {
    "date": "2025-12-13 20:15:00",
    "open": 110232.2,
    "low": 107918.99,
    "high": 114163.36,
    "close": 108251.78,
    "volume": 51526294
  },
  {
    "date": "2025-12-13 20:30:00",
    "open": 108251.78,
    "low": 105801.91,
    "high": 108557.91,
    "close": 106187.8,
    "volume": 54857347
  },
  {
    "date": "2025-12-13 20:45:00",
    "open": 106187.8,
    "low": 105220.8,
    "high": 109300.09,
    "close": 107513.62,
    "volume": 55757851
  },
  {
    "date": "2025-12-13 21:00:00",
    "open": 107513.62,
    "low": 104212.86,
    "high": 109883.55,
    "close": 105332.23,
    "volume": 42511497
  },
  {
    "date": "2025-12-13 21:15:00",
    "open": 105332.23,
    "low": 103037.59,
    "high": 105569.37,
    "close": 103945.57,
    "volume": 63138769
  },
  {
    "date": "2025-12-13 21:30:00",
    "open": 103945.57,
    "low": 98046.54,
    "high": 106694.28,
    "close": 101878.71,
    "volume": 54874798
  },
  {
    "date": "2025-12-13 21:45:00",
    "open": 101878.71,
    "low": 99570.52,
    "high": 104582.7,
    "close": 100371.76,
    "volume": 64077440
  },
  {
    "date": "2025-12-13 22:00:00",
    "open": 100371.76,
    "low": 98500.74,
    "high": 103325.05,
    "close": 102102.88,
    "volume": 46539749
  },
  {
    "date": "2025-12-13 22:15:00",
    "open": 102102.88,
    "low": 101823.08,
    "high": 106317.98,
    "close": 103689.37,
    "volume": 179314154
  },
  {
    "date": "2025-12-13 22:30:00",
    "open": 103689.37,
    "low": 99397.58,
    "high": 105935.48,
    "close": 101842.13,
    "volume": 51041746
  },
  {
    "date": "2025-12-13 22:45:00",
    "open": 101842.13,
    "low": 101310.92,
    "high": 103317.77,
    "close": 102520.56,
    "volume": 60128951
  },
  {
    "date": "2025-12-13 23:00:00",
    "open": 102520.56,
    "low": 101561.18,
    "high": 103005.01,
    "close": 102140.58,
    "volume": 56500221
  },
  {
    "date": "2025-12-13 23:15:00",
    "open": 102140.58,
    "low": 101459.57,
    "high": 106076.39,
    "close": 103825.09,
    "volume": 48248317
  },
  {
    "date": "2025-12-13 23:30:00",
    "open": 103825.09,
    "low": 100336.9,
    "high": 105941.5,
    "close": 102102.38,
    "volume": 57020736
  },
  {
    "date": "2025-12-13 23:45:00",
    "open": 102102.38,
    "low": 98804.19,
    "high": 106163.34,
    "close": 103796.32,
    "volume": 43200535
  },
  {
    "date": "2025-12-14 00:00:00",
    "open": 103796.32,
    "low": 99859.13,
    "high": 108529.2,
    "close": 106300.95,
    "volume": 129663557
  },
  {
    "date": "2025-12-14 00:15:00",
    "open": 106300.95,
    "low": 104958.71,
    "high": 110091.2,
    "close": 107833.7,
    "volume": 50165238
  },
  {
    "date": "2025-12-14 00:30:00",
    "open": 107833.7,
    "low": 105682.42,
    "high": 110839.03,
    "close": 108948.82,
    "volume": 114674724
  },
  {
    "date": "2025-12-14 00:45:00",
    "open": 108948.82,
    "low": 106291.99,
    "high": 109515.57,
    "close": 107507.26,
    "volume": 47454714
  },
  {
    "date": "2025-12-14 01:00:00",
    "open": 107507.26,
    "low": 104564.23,
    "high": 112836.54,
    "close": 109602.39,
    "volume": 57692940
  },
  {
    "date": "2025-12-14 01:15:00",
    "open": 109602.39,
    "low": 109092.75,
    "high": 111796.65,
    "close": 111153.34,
    "volume": 46522737
  },
  {
    "date": "2025-12-14 01:30:00",
    "open": 111153.34,
    "low": 107839.98,
    "high": 112986.87,
    "close": 110044.59,
    "volume": 45546782
  },
  {
    "date": "2025-12-14 01:45:00",
    "open": 110044.59,
    "low": 109161.53,
    "high": 111404.72,
    "close": 110546.6,
    "volume": 51363417
  },
  {
    "date": "2025-12-14 02:00:00",
    "open": 110546.6,
    "low": 66314.15,
    "high": 110929.74,
    "close": 93543.2,
    "volume": 156010261
  },
  {
    "date": "2025-12-14 02:15:00",
    "open": 93543.2,
    "low": 92051.04,
    "high": 96030.48,
    "close": 94935.54,
    "volume": 61669441
  },
  {
    "date": "2025-12-14 02:30:00",
    "open": 94935.54,
    "low": 89813.49,
    "high": 111722.42,
    "close": 100538.04,
    "volume": 143719334
  },
  {
    "date": "2025-12-14 02:45:00",
    "open": 100538.04,
    "low": 100117.48,
    "high": 100858.47,
    "close": 100286.17,
    "volume": 71279558
  },
  {
    "date": "2025-12-14 03:00:00",
    "open": 100286.17,
    "low": 99205.85,
    "high": 101694.22,
    "close": 99404.24,
    "volume": 62885344
  },
  {
    "date": "2025-12-14 03:15:00",
    "open": 99404.24,
    "low": 98779.66,
    "high": 99966.2,
    "close": 99071.89,
    "volume": 53318448
  },
  {
    "date": "2025-12-14 03:30:00",
    "open": 99071.89,
    "low": 97490.19,
    "high": 100268.82,
    "close": 97605.33,
    "volume": 59543855
  },
  {
    "date": "2025-12-14 03:45:00",
    "open": 97605.33,
    "low": 96486.72,
    "high": 98125.35,
    "close": 97116.46,
    "volume": 54715732
  },
  {
    "date": "2025-12-14 04:00:00",
    "open": 97116.46,
    "low": 96547.01,
    "high": 98556.05,
    "close": 98385.73,
    "volume": 60459735
  },
  {
    "date": "2025-12-14 04:15:00",
    "open": 98385.73,
    "low": 96254.32,
    "high": 101955.16,
    "close": 99550.74,
    "volume": 52812214
  },
  {
    "date": "2025-12-14 04:30:00",
    "open": 99550.74,
    "low": 96136.11,
    "high": 100641.66,
    "close": 98185.27,
    "volume": 44960145
  },
  {
    "date": "2025-12-14 04:45:00",
    "open": 98185.27,
    "low": 96074.96,
    "high": 100930.93,
    "close": 99690.61,
    "volume": 64895880
  },
  {
    "date": "2025-12-14 05:00:00",
    "open": 99690.61,
    "low": 95858.87,
    "high": 103329.85,
    "close": 97566.38,
    "volume": 62151823
  },
  {
    "date": "2025-12-14 05:15:00",
    "open": 97566.38,
    "low": 95554.31,
    "high": 100096.26,
    "close": 96111.35,
    "volume": 43419271
  },
  {
    "date": "2025-12-14 05:30:00",
    "open": 96111.35,
    "low": 94623.11,
    "high": 97162.83,
    "close": 95259.88,
    "volume": 59735030
  },
  {
    "date": "2025-12-14 05:45:00",
    "open": 95259.88,
    "low": 92130.77,
    "high": 97527.72,
    "close": 93690.93,
    "volume": 55137432
  },
  {
    "date": "2025-12-14 06:00:00",
    "open": 93690.93,
    "low": 92169.87,
    "high": 95127.79,
    "close": 94439.93,
    "volume": 60760287
  },
  {
    "date": "2025-12-14 06:15:00",
    "open": 94439.93,
    "low": 91339.19,
    "high": 95605.47,
    "close": 92986.37,
    "volume": 50486298
  },
  {
    "date": "2025-12-14 06:30:00",
    "open": 92986.37,
    "low": 91252.9,
    "high": 94258.93,
    "close": 92330.94,
    "volume": 44705119
  },
  {
    "date": "2025-12-14 06:45:00",
    "open": 92330.94,
    "low": 73020.26,
    "high": 108181.77,
    "close": 107294.1,
    "volume": 179986405
  },
  {
    "date": "2025-12-14 07:00:00",
    "open": 107294.1,
    "low": 105801.64,
    "high": 108213.4,
    "close": 106718.94,
    "volume": 40168100
  },
  {
    "date": "2025-12-14 07:15:00",
    "open": 106718.94,
    "low": 106279.65,
    "high": 107477.56,
    "close": 106959.44,
    "volume": 78769193
  },
  {
    "date": "2025-12-14 07:30:00",
    "open": 106959.44,
    "low": 105872.32,
    "high": 109826.02,
    "close": 108145.89,
    "volume": 55997563
  },
  {
    "date": "2025-12-14 07:45:00",
    "open": 108145.89,
    "low": 102680.84,
    "high": 110482.56,
    "close": 105944.01,
    "volume": 48814160
  },
  {
    "date": "2025-12-14 08:00:00",
    "open": 105944.01,
    "low": 103132.84,
    "high": 109507.42,
    "close": 104159.6,
    "volume": 54446691
  },
  {
    "date": "2025-12-14 08:15:00",
    "open": 104159.6,
    "low": 103189.11,
    "high": 104502.44,
    "close": 103515.16,
    "volume": 61274334
  },
  {
    "date": "2025-12-14 08:30:00",
    "open": 103515.16,
    "low": 102043.02,
    "high": 104561.3,
    "close": 102983.56,
    "volume": 60100003
  },
  {
    "date": "2025-12-14 08:45:00",
    "open": 102983.56,
    "low": 101359.1,
    "high": 103279.94,
    "close": 102267.33,
    "volume": 55549350
  },
  {
    "date": "2025-12-14 09:00:00",
    "open": 102267.33,
    "low": 100109.59,
    "high": 103067.28,
    "close": 101474.06,
    "volume": 64993909
  },
  {
    "date": "2025-12-14 09:15:00",
    "open": 101474.06,
    "low": 96732.75,
    "high": 108315.2,
    "close": 107492.71,
    "volume": 161494873
  },
  {
    "date": "2025-12-14 09:30:00",
    "open": 107492.71,
    "low": 105240.07,
    "high": 108938.45,
    "close": 105748.74,
    "volume": 50802269
  },
  {
    "date": "2025-12-14 09:45:00",
    "open": 105748.74,
    "low": 104683.02,
    "high": 106450.64,
    "close": 105365.61,
    "volume": 44148847
  },
  {
    "date": "2025-12-14 10:00:00",
    "open": 105365.61,
    "low": 103549.71,
    "high": 105740.37,
    "close": 103944.2,
    "volume": 61982622
  },
  {
    "date": "2025-12-14 10:15:00",
    "open": 103944.2,
    "low": 103645.36,
    "high": 106527.36,
    "close": 104907.66,
    "volume": 43261825
  },
  {
    "date": "2025-12-14 10:30:00",
    "open": 104907.66,
    "low": 98780.44,
    "high": 120553.06,
    "close": 110542.71,
    "volume": 116617337
  },
  {
    "date": "2025-12-14 10:45:00",
    "open": 110542.71,
    "low": 105725.07,
    "high": 110709.54,
    "close": 108719.75,
    "volume": 64215541
  },
  {
    "date": "2025-12-14 11:00:00",
    "open": 108719.75,
    "low": 106253.25,
    "high": 111107.19,
    "close": 107099.38,
    "volume": 59497524
  },
  {
    "date": "2025-12-14 11:15:00",
    "open": 107099.38,
    "low": 104982.78,
    "high": 108507.63,
    "close": 108286.25,
    "volume": 57941284
  },
  {
    "date": "2025-12-14 11:30:00",
    "open": 108286.25,
    "low": 107583.96,
    "high": 108784.09,
    "close": 107989.98,
    "volume": 58381988
  },
  {
    "date": "2025-12-14 11:45:00",
    "open": 107989.98,
    "low": 106112.9,
    "high": 111202.99,
    "close": 109254.4,
    "volume": 57924573
  },
  {
    "date": "2025-12-14 12:00:00",
    "open": 109254.4,
    "low": 107841.15,
    "high": 110046.02,
    "close": 108639.67,
    "volume": 58754225
  },
  {
    "date": "2025-12-14 12:15:00",
    "open": 108639.67,
    "low": 106107.93,
    "high": 111119.39,
    "close": 110326.91,
    "volume": 60939280
  },
  {
    "date": "2025-12-14 12:30:00",
    "open": 110326.91,
    "low": 104154.96,
    "high": 121393.86,
    "close": 114100.33,
    "volume": 169344317
  },
  {
    "date": "2025-12-14 12:45:00",
    "open": 114100.33,
    "low": 112340.19,
    "high": 117127.66,
    "close": 115657.9,
    "volume": 43642374
  },
  {
    "date": "2025-12-14 13:00:00",
    "open": 115657.9,
    "low": 115032.01,
    "high": 119640.3,
    "close": 117253.07,
    "volume": 75100659
  },
  {
    "date": "2025-12-14 13:15:00",
    "open": 117253.07,
    "low": 114696.96,
    "high": 118186.75,
    "close": 115652.23,
    "volume": 41201034
  },
  {
    "date": "2025-12-14 13:30:00",
    "open": 115652.23,
    "low": 109650.64,
    "high": 119342.69,
    "close": 113669.93,
    "volume": 64819430
  },
  {
    "date": "2025-12-14 13:45:00",
    "open": 113669.93,
    "low": 111791.13,
    "high": 114731.16,
    "close": 112753.85,
    "volume": 54891384
  },
  {
    "date": "2025-12-14 14:00:00",
    "open": 112753.85,
    "low": 112049.77,
    "high": 115962.72,
    "close": 114017.61,
    "volume": 59667936
  },
  {
    "date": "2025-12-14 14:15:00",
    "open": 114017.61,
    "low": 113267.31,
    "high": 114133.76,
    "close": 113793.67,
    "volume": 48414536
  },
  {
    "date": "2025-12-14 14:30:00",
    "open": 113793.67,
    "low": 104469.2,
    "high": 114332.22,
    "close": 108021.42,
    "volume": 82675611
  },
  {
    "date": "2025-12-14 14:45:00",
    "open": 108021.42,
    "low": 105615.13,
    "high": 109275.91,
    "close": 107032.12,
    "volume": 44933644
  },
  {
    "date": "2025-12-14 15:00:00",
    "open": 107032.12,
    "low": 96065.61,
    "high": 125749.52,
    "close": 115550.12,
    "volume": 153360214
  },
  {
    "date": "2025-12-14 15:15:00",
    "open": 115550.12,
    "low": 115154.4,
    "high": 116501.34,
    "close": 115952.29,
    "volume": 64804277
  },
  {
    "date": "2025-12-14 15:30:00",
    "open": 115952.29,
    "low": 115003.66,
    "high": 116489.73,
    "close": 115630.06,
    "volume": 57943549
  },
  {
    "date": "2025-12-14 15:45:00",
    "open": 115630.06,
    "low": 114691.25,
    "high": 117178.71,
    "close": 116111.25,
    "volume": 58291845
  },
  {
    "date": "2025-12-14 16:00:00",
    "open": 116111.25,
    "low": 109494.35,
    "high": 116513.76,
    "close": 113862.99,
    "volume": 128561445
  },
  {
    "date": "2025-12-14 16:15:00",
    "open": 113862.99,
    "low": 110607.58,
    "high": 117166.35,
    "close": 111773.18,
    "volume": 42255355
  },
  {
    "date": "2025-12-14 16:30:00",
    "open": 111773.18,
    "low": 110674.75,
    "high": 112196.59,
    "close": 111223.96,
    "volume": 61817005
  },
  {
    "date": "2025-12-14 16:45:00",
    "open": 111223.96,
    "low": 110388.92,
    "high": 111752.02,
    "close": 110833.41,
    "volume": 52680570
  },
  {
    "date": "2025-12-14 17:00:00",
    "open": 110833.41,
    "low": 110141.5,
    "high": 112623.72,
    "close": 111416.54,
    "volume": 50709306
  },
  {
    "date": "2025-12-14 17:15:00",
    "open": 111416.54,
    "low": 107441.83,
    "high": 115412.78,
    "close": 113361.52,
    "volume": 106891452
  },
  {
    "date": "2025-12-14 17:30:00",
    "open": 113361.52,
    "low": 108331.37,
    "high": 115903.42,
    "close": 111298.39,
    "volume": 60946264
  },
  {
    "date": "2025-12-14 17:45:00",
    "open": 111298.39,
    "low": 108945.88,
    "high": 111755.29,
    "close": 109818.4,
    "volume": 54502978
  },
  {
    "date": "2025-12-14 18:00:00",
    "open": 109818.4,
    "low": 109042.37,
    "high": 110442.27,
    "close": 109284.82,
    "volume": 55946695
  },
  {
    "date": "2025-12-14 18:15:00",
    "open": 109284.82,
    "low": 107045.06,
    "high": 109659.86,
    "close": 107616.33,
    "volume": 63859777
  },
  {
    "date": "2025-12-14 18:30:00",
    "open": 107616.33,
    "low": 104982.88,
    "high": 109435.75,
    "close": 105674.16,
    "volume": 61588661
  },
  {
    "date": "2025-12-14 18:45:00",
    "open": 105674.16,
    "low": 103578.7,
    "high": 108111.68,
    "close": 107317.52,
    "volume": 63414571
  },
  {
    "date": "2025-12-14 19:00:00",
    "open": 107317.52,
    "low": 106554.46,
    "high": 108664.65,
    "close": 108206.92,
    "volume": 88347964
  },
  {
    "date": "2025-12-14 19:15:00",
    "open": 108206.92,
    "low": 105061.01,
    "high": 109362.45,
    "close": 106776.56,
    "volume": 60683408
  },
  {
    "date": "2025-12-14 19:30:00",
    "open": 106776.56,
    "low": 106353.27,
    "high": 110685.12,
    "close": 108929,
    "volume": 57895504
  },
  {
    "date": "2025-12-14 19:45:00",
    "open": 108929,
    "low": 108668.81,
    "high": 113198.3,
    "close": 110374.61,
    "volume": 43318891
  },
  {
    "date": "2025-12-14 20:00:00",
    "open": 110374.61,
    "low": 101617.75,
    "high": 127649.84,
    "close": 119395.45,
    "volume": 185632643
  },
  {
    "date": "2025-12-14 20:15:00",
    "open": 119395.45,
    "low": 116038.94,
    "high": 121450.75,
    "close": 117634.89,
    "volume": 63076537
  },
  {
    "date": "2025-12-14 20:30:00",
    "open": 117634.89,
    "low": 107357.62,
    "high": 123174.1,
    "close": 111921.33,
    "volume": 137532562
  },
  {
    "date": "2025-12-14 20:45:00",
    "open": 111921.33,
    "low": 105024.76,
    "high": 123012.91,
    "close": 119378.35,
    "volume": 109393703
  },
  {
    "date": "2025-12-14 21:00:00",
    "open": 119378.35,
    "low": 95972.6,
    "high": 142706.64,
    "close": 103698.01,
    "volume": 141344303
  },
  {
    "date": "2025-12-14 21:15:00",
    "open": 103698.01,
    "low": 103198.96,
    "high": 106611.05,
    "close": 105054.22,
    "volume": 61883679
  },
  {
    "date": "2025-12-14 21:30:00",
    "open": 105054.22,
    "low": 101261.71,
    "high": 106354.17,
    "close": 103757.35,
    "volume": 53411892
  },
  {
    "date": "2025-12-14 21:45:00",
    "open": 103757.35,
    "low": 101591.18,
    "high": 107959.19,
    "close": 105732.03,
    "volume": 46485988
  },
  {
    "date": "2025-12-14 22:00:00",
    "open": 105732.03,
    "low": 102391.08,
    "high": 108928.71,
    "close": 107628.33,
    "volume": 55295008
  },
  {
    "date": "2025-12-14 22:15:00",
    "open": 107628.33,
    "low": 105252.31,
    "high": 113669.63,
    "close": 112945.32,
    "volume": 135719960
  },
  {
    "date": "2025-12-14 22:30:00",
    "open": 112945.32,
    "low": 93558.87,
    "high": 132612.84,
    "close": 123964.26,
    "volume": 142304578
  },
  {
    "date": "2025-12-14 22:45:00",
    "open": 123964.26,
    "low": 122559.85,
    "high": 124553.31,
    "close": 123519.32,
    "volume": 42947210
  },
  {
    "date": "2025-12-14 23:00:00",
    "open": 123519.32,
    "low": 119801.95,
    "high": 125737.69,
    "close": 121535.2,
    "volume": 47546272
  },
  {
    "date": "2025-12-14 23:15:00",
    "open": 121535.2,
    "low": 119525.62,
    "high": 122039.84,
    "close": 120251.89,
    "volume": 63002633
  },
  {
    "date": "2025-12-14 23:30:00",
    "open": 120251.89,
    "low": 115131.2,
    "high": 121992.13,
    "close": 118138.02,
    "volume": 44867357
  },
  {
    "date": "2025-12-14 23:45:00",
    "open": 118138.02,
    "low": 113935.46,
    "high": 122147.78,
    "close": 120233.5,
    "volume": 62478814
  },
  {
    "date": "2025-12-15 00:00:00",
    "open": 120233.5,
    "low": 114499.67,
    "high": 127346.71,
    "close": 124136.82,
    "volume": 76120330
  },
  {
    "date": "2025-12-15 00:15:00",
    "open": 124136.82,
    "low": 123692.56,
    "high": 127246.95,
    "close": 126733.73,
    "volume": 42343875
  },
  {
    "date": "2025-12-15 00:30:00",
    "open": 126733.73,
    "low": 125271.04,
    "high": 129213.04,
    "close": 128870.39,
    "volume": 43932305
  },
  {
    "date": "2025-12-15 00:45:00",
    "open": 128870.39,
    "low": 127111.41,
    "high": 133857.53,
    "close": 130889.01,
    "volume": 52095498
  },
  {
    "date": "2025-12-15 01:00:00",
    "open": 130889.01,
    "low": 128057.62,
    "high": 132661.49,
    "close": 129804.37,
    "volume": 57875206
  },
  {
    "date": "2025-12-15 01:15:00",
    "open": 129804.37,
    "low": 127524.78,
    "high": 135245.16,
    "close": 132221.86,
    "volume": 58027906
  },
  {
    "date": "2025-12-15 01:30:00",
    "open": 132221.86,
    "low": 125701.85,
    "high": 135798.3,
    "close": 128053.88,
    "volume": 120917372
  },
  {
    "date": "2025-12-15 01:45:00",
    "open": 128053.88,
    "low": 127034.98,
    "high": 128961.1,
    "close": 128784.63,
    "volume": 56128526
  },
  {
    "date": "2025-12-15 02:00:00",
    "open": 128784.63,
    "low": 128647.2,
    "high": 128919.06,
    "close": 128789.15,
    "volume": 50447250
  },
  {
    "date": "2025-12-15 02:15:00",
    "open": 128789.15,
    "low": 126538.86,
    "high": 130385.26,
    "close": 129974.48,
    "volume": 47584786
  },
  {
    "date": "2025-12-15 02:30:00",
    "open": 129974.48,
    "low": 128320.93,
    "high": 131911.85,
    "close": 128970.29,
    "volume": 156861785
  },
  {
    "date": "2025-12-15 02:45:00",
    "open": 128970.29,
    "low": 126183.68,
    "high": 134109.84,
    "close": 131099.53,
    "volume": 53156938
  },
  {
    "date": "2025-12-15 03:00:00",
    "open": 131099.53,
    "low": 124264.35,
    "high": 132042.66,
    "close": 128622.39,
    "volume": 57913128
  },
  {
    "date": "2025-12-15 03:15:00",
    "open": 128622.39,
    "low": 127224.59,
    "high": 129141.2,
    "close": 127736.82,
    "volume": 53713531
  },
  {
    "date": "2025-12-15 03:30:00",
    "open": 127736.82,
    "low": 126780.96,
    "high": 128512.05,
    "close": 127216.26,
    "volume": 55650307
  },
  {
    "date": "2025-12-15 03:45:00",
    "open": 127216.26,
    "low": 125441.51,
    "high": 130740.15,
    "close": 128447.28,
    "volume": 57581969
  },
  {
    "date": "2025-12-15 04:00:00",
    "open": 128447.28,
    "low": 125402.6,
    "high": 129493.35,
    "close": 127190.69,
    "volume": 49472732
  },
  {
    "date": "2025-12-15 04:15:00",
    "open": 127190.69,
    "low": 124195.68,
    "high": 133372.46,
    "close": 129485.44,
    "volume": 48875641
  },
  {
    "date": "2025-12-15 04:30:00",
    "open": 129485.44,
    "low": 110796.83,
    "high": 140729.06,
    "close": 120538.7,
    "volume": 119681439
  },
  {
    "date": "2025-12-15 04:45:00",
    "open": 120538.7,
    "low": 110560.87,
    "high": 128114.8,
    "close": 116065.98,
    "volume": 87142345
  },
  {
    "date": "2025-12-15 05:00:00",
    "open": 116065.98,
    "low": 114595.29,
    "high": 119271.84,
    "close": 117256.26,
    "volume": 54318126
  },
  {
    "date": "2025-12-15 05:15:00",
    "open": 117256.26,
    "low": 116176.1,
    "high": 118412.27,
    "close": 118250.25,
    "volume": 61375446
  },
  {
    "date": "2025-12-15 05:30:00",
    "open": 118250.25,
    "low": 97245.93,
    "high": 125474.05,
    "close": 107164.34,
    "volume": 127239007
  },
  {
    "date": "2025-12-15 05:45:00",
    "open": 107164.34,
    "low": 106381.75,
    "high": 108248.81,
    "close": 107835.57,
    "volume": 59072981
  },
  {
    "date": "2025-12-15 06:00:00",
    "open": 107835.57,
    "low": 90618.76,
    "high": 119300.71,
    "close": 118088.73,
    "volume": 137266090
  },
  {
    "date": "2025-12-15 06:15:00",
    "open": 118088.73,
    "low": 115812.03,
    "high": 118855.46,
    "close": 116436.88,
    "volume": 42193394
  },
  {
    "date": "2025-12-15 06:30:00",
    "open": 116436.88,
    "low": 114249.01,
    "high": 121188.19,
    "close": 118796.75,
    "volume": 42776483
  },
  {
    "date": "2025-12-15 06:45:00",
    "open": 118796.75,
    "low": 118168.48,
    "high": 121898.19,
    "close": 119811.81,
    "volume": 50611674
  },
  {
    "date": "2025-12-15 07:00:00",
    "open": 119811.81,
    "low": 119013.14,
    "high": 120847.21,
    "close": 120263.3,
    "volume": 50801328
  },
  {
    "date": "2025-12-15 07:15:00",
    "open": 120263.3,
    "low": 114406.72,
    "high": 124326.48,
    "close": 118194.21,
    "volume": 41652947
  },
  {
    "date": "2025-12-15 07:30:00",
    "open": 118194.21,
    "low": 118049.24,
    "high": 121121.56,
    "close": 119496.17,
    "volume": 41898326
  },
  {
    "date": "2025-12-15 07:45:00",
    "open": 119496.17,
    "low": 119316.38,
    "high": 121585.35,
    "close": 120981.74,
    "volume": 50647783
  },
  {
    "date": "2025-12-15 08:00:00",
    "open": 120981.74,
    "low": 118063.15,
    "high": 122716.89,
    "close": 122559.16,
    "volume": 42408644
  },
  {
    "date": "2025-12-15 08:15:00",
    "open": 122559.16,
    "low": 119175.91,
    "high": 127347.63,
    "close": 124709.09,
    "volume": 51859683
  },
  {
    "date": "2025-12-15 08:30:00",
    "open": 124709.09,
    "low": 121977.69,
    "high": 126399.68,
    "close": 123721.25,
    "volume": 58522890
  },
  {
    "date": "2025-12-15 08:45:00",
    "open": 123721.25,
    "low": 120044.06,
    "high": 126791.28,
    "close": 125595,
    "volume": 41457336
  },
  {
    "date": "2025-12-15 09:00:00",
    "open": 125595,
    "low": 124494.9,
    "high": 127807.14,
    "close": 126784.1,
    "volume": 56517754
  },
  {
    "date": "2025-12-15 09:15:00",
    "open": 126784.1,
    "low": 125442.86,
    "high": 127084.15,
    "close": 125970.69,
    "volume": 49921265
  },
  {
    "date": "2025-12-15 09:30:00",
    "open": 125970.69,
    "low": 125840.03,
    "high": 126101.12,
    "close": 125968.12,
    "volume": 49132248
  },
  {
    "date": "2025-12-15 09:45:00",
    "open": 125968.12,
    "low": 121851.35,
    "high": 127088.22,
    "close": 124596.37,
    "volume": 45249061
  },
  {
    "date": "2025-12-15 10:00:00",
    "open": 124596.37,
    "low": 113819,
    "high": 130188.27,
    "close": 120408.48,
    "volume": 105841431
  },
  {
    "date": "2025-12-15 10:15:00",
    "open": 120408.48,
    "low": 118866.46,
    "high": 121271.15,
    "close": 119263.5,
    "volume": 46739035
  },
  {
    "date": "2025-12-15 10:30:00",
    "open": 119263.5,
    "low": 117422.31,
    "high": 120337.74,
    "close": 117634.84,
    "volume": 103929192
  },
  {
    "date": "2025-12-15 10:45:00",
    "open": 117634.84,
    "low": 110114.29,
    "high": 120472.18,
    "close": 114995.19,
    "volume": 40215970
  },
  {
    "date": "2025-12-15 11:00:00",
    "open": 114995.19,
    "low": 114326.86,
    "high": 115859.2,
    "close": 115330.94,
    "volume": 46569943
  },
  {
    "date": "2025-12-15 11:15:00",
    "open": 115330.94,
    "low": 110066.36,
    "high": 118138.57,
    "close": 113400.78,
    "volume": 49869912
  },
  {
    "date": "2025-12-15 11:30:00",
    "open": 113400.78,
    "low": 112861.4,
    "high": 114616.49,
    "close": 113825.78,
    "volume": 43854896
  },
  {
    "date": "2025-12-15 11:45:00",
    "open": 113825.78,
    "low": 110991.27,
    "high": 116773.48,
    "close": 115272.19,
    "volume": 60204783
  },
  {
    "date": "2025-12-15 12:00:00",
    "open": 115272.19,
    "low": 115107.13,
    "high": 115412.06,
    "close": 115251.38,
    "volume": 46444762
  },
  {
    "date": "2025-12-15 12:15:00",
    "open": 115251.38,
    "low": 113242.7,
    "high": 115434.08,
    "close": 114205.46,
    "volume": 50397300
  },
  {
    "date": "2025-12-15 12:30:00",
    "open": 114205.46,
    "low": 114007.48,
    "high": 114731.12,
    "close": 114550.9,
    "volume": 49390636
  },
  {
    "date": "2025-12-15 12:45:00",
    "open": 114550.9,
    "low": 114060.47,
    "high": 116065.29,
    "close": 115737.62,
    "volume": 54048039
  },
  {
    "date": "2025-12-15 13:00:00",
    "open": 115737.62,
    "low": 101037.09,
    "high": 119141.46,
    "close": 108402.08,
    "volume": 152113321
  },
  {
    "date": "2025-12-15 13:15:00",
    "open": 108402.08,
    "low": 107011.63,
    "high": 109050.2,
    "close": 107683.54,
    "volume": 46957907
  },
  {
    "date": "2025-12-15 13:30:00",
    "open": 107683.54,
    "low": 107530.7,
    "high": 108139.58,
    "close": 107918.31,
    "volume": 40492797
  },
  {
    "date": "2025-12-15 13:45:00",
    "open": 107918.31,
    "low": 107697.87,
    "high": 108960.63,
    "close": 108263.59,
    "volume": 52441196
  },
  {
    "date": "2025-12-15 14:00:00",
    "open": 108263.59,
    "low": 107218.39,
    "high": 147510.17,
    "close": 124072.89,
    "volume": 175686817
  },
  {
    "date": "2025-12-15 14:15:00",
    "open": 124072.89,
    "low": 120136.02,
    "high": 130225.87,
    "close": 126325.68,
    "volume": 50866858
  },
  {
    "date": "2025-12-15 14:30:00",
    "open": 126325.68,
    "low": 123533.29,
    "high": 127587.09,
    "close": 124986.12,
    "volume": 50332574
  },
  {
    "date": "2025-12-15 14:45:00",
    "open": 124986.12,
    "low": 122761.35,
    "high": 126477.85,
    "close": 124249.69,
    "volume": 61749314
  },
  {
    "date": "2025-12-15 15:00:00",
    "open": 124249.69,
    "low": 121933.06,
    "high": 127469.88,
    "close": 125362.23,
    "volume": 43132201
  },
  {
    "date": "2025-12-15 15:15:00",
    "open": 125362.23,
    "low": 120778.58,
    "high": 126488.31,
    "close": 123127.7,
    "volume": 60010321
  },
  {
    "date": "2025-12-15 15:30:00",
    "open": 123127.7,
    "low": 115335.5,
    "high": 143805.8,
    "close": 130138.21,
    "volume": 105473266
  },
  {
    "date": "2025-12-15 15:45:00",
    "open": 130138.21,
    "low": 127564.07,
    "high": 135302.14,
    "close": 132354.61,
    "volume": 54353486
  },
  {
    "date": "2025-12-15 16:00:00",
    "open": 132354.61,
    "low": 112935.2,
    "high": 148073.13,
    "close": 142040.25,
    "volume": 174563747
  },
  {
    "date": "2025-12-15 16:15:00",
    "open": 142040.25,
    "low": 140747.27,
    "high": 142228.3,
    "close": 141519.6,
    "volume": 54978543
  },
  {
    "date": "2025-12-15 16:30:00",
    "open": 141519.6,
    "low": 140077.89,
    "high": 144085.91,
    "close": 142501.55,
    "volume": 47571987
  },
  {
    "date": "2025-12-15 16:45:00",
    "open": 142501.55,
    "low": 140714.23,
    "high": 143206.83,
    "close": 141638.95,
    "volume": 47276137
  },
  {
    "date": "2025-12-15 17:00:00",
    "open": 141638.95,
    "low": 138394.51,
    "high": 142397.74,
    "close": 140590.5,
    "volume": 48770007
  },
  {
    "date": "2025-12-15 17:15:00",
    "open": 140590.5,
    "low": 138598.21,
    "high": 144386.78,
    "close": 142611.94,
    "volume": 60045259
  },
  {
    "date": "2025-12-15 17:30:00",
    "open": 142611.94,
    "low": 140542.05,
    "high": 147174.79,
    "close": 144731.34,
    "volume": 45670553
  },
  {
    "date": "2025-12-15 17:45:00",
    "open": 144731.34,
    "low": 144176.78,
    "high": 145252.15,
    "close": 144352.72,
    "volume": 41830519
  },
  {
    "date": "2025-12-15 18:00:00",
    "open": 144352.72,
    "low": 143834.97,
    "high": 148051.21,
    "close": 145792.24,
    "volume": 62506015
  },
  {
    "date": "2025-12-15 18:15:00",
    "open": 145792.24,
    "low": 141033.41,
    "high": 151071.64,
    "close": 148375.34,
    "volume": 56761295
  },
  {
    "date": "2025-12-15 18:30:00",
    "open": 148375.34,
    "low": 112651.73,
    "high": 162406.01,
    "close": 131572.94,
    "volume": 140816782
  },
  {
    "date": "2025-12-15 18:45:00",
    "open": 131572.94,
    "low": 130683.19,
    "high": 133108.78,
    "close": 132370.34,
    "volume": 52564899
  },
  {
    "date": "2025-12-15 19:00:00",
    "open": 132370.34,
    "low": 132159.17,
    "high": 134836.05,
    "close": 134200.61,
    "volume": 49099407
  },
  {
    "date": "2025-12-15 19:15:00",
    "open": 134200.61,
    "low": 131951.93,
    "high": 136046.32,
    "close": 135900.65,
    "volume": 63796396
  },
  {
    "date": "2025-12-15 19:30:00",
    "open": 135900.65,
    "low": 135065.53,
    "high": 138738.77,
    "close": 138026.3,
    "volume": 41614151
  },
  {
    "date": "2025-12-15 19:45:00",
    "open": 138026.3,
    "low": 135069.35,
    "high": 140273.34,
    "close": 136916.91,
    "volume": 45472744
  },
  {
    "date": "2025-12-15 20:00:00",
    "open": 136916.91,
    "low": 136030.52,
    "high": 140269.81,
    "close": 138390.04,
    "volume": 43712976
  },
  {
    "date": "2025-12-15 20:15:00",
    "open": 138390.04,
    "low": 136535.53,
    "high": 139106.9,
    "close": 137240.21,
    "volume": 46437833
  },
  {
    "date": "2025-12-15 20:30:00",
    "open": 137240.21,
    "low": 135798.97,
    "high": 138319.87,
    "close": 136646.92,
    "volume": 51397794
  },
  {
    "date": "2025-12-15 20:45:00",
    "open": 136646.92,
    "low": 131522.6,
    "high": 142558.13,
    "close": 139362.49,
    "volume": 62880663
  },
  {
    "date": "2025-12-15 21:00:00",
    "open": 139362.49,
    "low": 139203.66,
    "high": 139586.08,
    "close": 139415.46,
    "volume": 52097317
  },
  {
    "date": "2025-12-15 21:15:00",
    "open": 139415.46,
    "low": 133983.56,
    "high": 152122.17,
    "close": 144185.9,
    "volume": 111791155
  },
  {
    "date": "2025-12-15 21:30:00",
    "open": 144185.9,
    "low": 141011.22,
    "high": 144897.43,
    "close": 142440.42,
    "volume": 48762277
  },
  {
    "date": "2025-12-15 21:45:00",
    "open": 142440.42,
    "low": 125001.48,
    "high": 163309.6,
    "close": 151182.73,
    "volume": 87610275
  },
  {
    "date": "2025-12-15 22:00:00",
    "open": 151182.73,
    "low": 148845.09,
    "high": 151914.8,
    "close": 149180.19,
    "volume": 43852087
  },
  {
    "date": "2025-12-15 22:15:00",
    "open": 149180.19,
    "low": 148476.46,
    "high": 150132.69,
    "close": 149732.75,
    "volume": 42544926
  },
  {
    "date": "2025-12-15 22:30:00",
    "open": 149732.75,
    "low": 131789.55,
    "high": 153002.68,
    "close": 136446.01,
    "volume": 124802490
  },
  {
    "date": "2025-12-15 22:45:00",
    "open": 136446.01,
    "low": 133905.97,
    "high": 137411.5,
    "close": 134967.95,
    "volume": 40284425
  },
  {
    "date": "2025-12-15 23:00:00",
    "open": 134967.95,
    "low": 132567.6,
    "high": 138233.04,
    "close": 136236.07,
    "volume": 43055996
  },
  {
    "date": "2025-12-15 23:15:00",
    "open": 136236.07,
    "low": 135454.83,
    "high": 137951.83,
    "close": 136784.53,
    "volume": 64028634
  },
  {
    "date": "2025-12-15 23:30:00",
    "open": 136784.53,
    "low": 135555.13,
    "high": 138509,
    "close": 137358.62,
    "volume": 44881600
  },
  {
    "date": "2025-12-15 23:45:00",
    "open": 137358.62,
    "low": 136409.93,
    "high": 139633.2,
    "close": 138418.49,
    "volume": 57612569
  },
  {
    "date": "2025-12-16 00:00:00",
    "open": 138418.49,
    "low": 137038.81,
    "high": 139864.35,
    "close": 137522.05,
    "volume": 64911456
  }
]